export const GET_ALL_VACCINES = "/doctor/v1/get-vaccine-data";
export const GET_VACCINE_BRANDS = "/doctor/v1/get_vaccine_brand_name";
export const CREATE_EDIT_PRE_VACCINE = "/api/v1/create_pre_vaccine";
export const CREATE_EDIT_CUSTOM_VACCINE = "api/v1/create_custom_pre_vaccine";
export const DELETE_CUSTOM_VACCINE = "api/v1/delete_pre_vaccine";
export const SCHEDULE_NEXT_DUE_DATE = "api/v1/create_cron_schedule";
